import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { Package } from "lucide-react";

const fmtIDR = (n) => "Rp" + Number(n || 0).toLocaleString("id-ID");

// Pratinjau gambar item booking: thumbnail kecil + lightbox saat diklik
export function ItemThumbs({ items = [], size = 44 }) {
  const [active, setActive] = useState(null);
  if (!items.length) return null;
  return (
    <>
      <div className="flex flex-wrap gap-1.5 mt-2" data-testid="booking-item-thumbs">
        {items.map((it, i) => {
          const label = `${it.product_name}${it.variant_name ? ` · ${it.variant_name}` : ""}`;
          return (
            <button
              key={i}
              type="button"
              onClick={(e) => { e.stopPropagation(); setActive(it); }}
              title={label}
              data-testid={`item-thumb-${i}`}
              className="relative shrink-0 rounded-md border border-neutral-200 overflow-hidden bg-neutral-50 hover:border-red-500 transition-colors"
              style={{ width: size, height: size }}
            >
              {it.image_url
                ? <img src={it.image_url} alt={label} className="w-full h-full object-cover" />
                : <div className="w-full h-full flex items-center justify-center"><Package className="w-4 h-4 text-neutral-300" /></div>}
              <span className="absolute bottom-0 right-0 text-[9px] font-bold text-white bg-black/60 px-1 rounded-tl">x{it.quantity}</span>
            </button>
          );
        })}
      </div>
      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-md p-0 overflow-hidden" data-testid="item-image-lightbox" aria-describedby={undefined}>
          <DialogTitle className="sr-only">Detail Item Booking</DialogTitle>
          {active && (
            <div>
              {active.image_url
                ? <img src={active.image_url} alt={active.product_name} className="w-full max-h-[60vh] object-contain bg-neutral-100" data-testid="lightbox-image" />
                : <div className="w-full h-56 flex items-center justify-center bg-neutral-100"><Package className="w-16 h-16 text-neutral-300" /></div>}
              <div className="p-4">
                <div className="font-display font-semibold text-neutral-900">{active.product_name}</div>
                {active.variant_name && <div className="text-xs uppercase font-bold text-blue-700 mt-0.5">{active.variant_name}</div>}
                <div className="flex justify-between text-sm mt-2">
                  <span className="text-neutral-500">Jumlah</span>
                  <span className="font-mono-tab font-semibold">x{active.quantity}</span>
                </div>
                {active.daily_price != null && (
                  <div className="flex justify-between text-sm mt-1">
                    <span className="text-neutral-500">Harga / hari</span>
                    <span className="font-mono-tab font-semibold" style={{ color: "var(--brand-primary)" }}>{fmtIDR(active.daily_price)}</span>
                  </div>
                )}
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
